"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductsTableFoot = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _productPriceInfo = require("../productColumn/productPriceInfo");
var _tableContext = require("./stateHelpers/tableContext");
var _tableHelpers = require("../../helpers/tableHelpers");
var _defaults = require("./defaults");
var _quoteHelpers = require("../../helpers/quoteHelpers");
var _productHelpers = require("../../helpers/productHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ProductsTableFoot = exports.ProductsTableFoot = function ProductsTableFoot(_ref) {
  var _ref$plans = _ref.plans,
    plans = _ref$plans === void 0 ? {} : _ref$plans,
    _ref$onPlanSelect = _ref.onPlanSelect,
    onPlanSelect = _ref$onPlanSelect === void 0 ? function () {} : _ref$onPlanSelect;
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    _useContext$tableCont = _useContext.tableContext,
    brand = _useContext$tableCont.brand,
    groupedProductNames = _useContext$tableCont.groupedProductNames,
    ProductGroupsKeyedByPlanNumber = _useContext$tableCont.ProductGroupsKeyedByPlanNumber,
    _useContext$tableStat = _useContext.tableState,
    dataIsUpdating = _useContext$tableStat.dataIsUpdating,
    productsAreMerged = _useContext$tableStat.productsAreMerged,
    selectedProduct = _useContext$tableStat.selectedProduct,
    productQuotes = _useContext$tableStat.productQuotes;
  var _ref2 = _defaults.DefaultProductTablePriceInfo[brand] || _defaults.DefaultProductTablePriceInfo["default"],
    title = _ref2.title;
  var CheckProductSelected = function CheckProductSelected(planNumber) {
    return selectedProduct && (planNumber === selectedProduct.planNumber || productsAreMerged && selectedProduct.basePlanNo === planNumber);
  };
  var HandleProductSelection = function HandleProductSelection(_ref3) {
    var productDefinition = _ref3.productDefinition;
    onPlanSelect({
      productDefinition: productDefinition
    });
  };
  var productCoverItemLabel = (0, _react.useMemo)(function () {
    var productLoadings = (0, _quoteHelpers.ExtractAllLoadings)({
      productQuotes: productQuotes
    });
    return !dataIsUpdating ? title({
      allLoadings: productLoadings
    }) : '';
  }, [productQuotes, dataIsUpdating, title]);
  return /*#__PURE__*/_react["default"].createElement("tfoot", null, /*#__PURE__*/_react["default"].createElement("tr", {
    className: "productNameFooters"
  }, plans && Object.values(plans).map(function (productDefinition, columnIndex) {
    var planNumber = productDefinition.planNumber;
    var planProductGroup = ProductGroupsKeyedByPlanNumber["Plan_".concat(planNumber)];
    var productName = (0, _productHelpers.GetProductName)({
      productDefinition: productDefinition,
      planProductGroup: planProductGroup,
      groupedProductNames: groupedProductNames,
      productsAreMerged: productsAreMerged
    });
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: "productTableFooter_".concat(planNumber)
    }, columnIndex === 0 && /*#__PURE__*/_react["default"].createElement("td", {
      className: "productCoverItemLabel"
    }, productCoverItemLabel), /*#__PURE__*/_react["default"].createElement("td", {
      className: (0, _tableHelpers.GetCellCssClass)({
        planNumber: planNumber,
        planProductGroup: planProductGroup,
        selectedProduct: selectedProduct,
        productsAreMerged: productsAreMerged
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "productNameFooter"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "productNameHeading"
    }, productName), /*#__PURE__*/_react["default"].createElement(_productPriceInfo.ProductPriceInfo, {
      productIsSelected: CheckProductSelected(planNumber),
      planNumber: planNumber,
      onPlanSelect: function onPlanSelect() {
        return HandleProductSelection({
          productDefinition: productDefinition
        });
      }
    }))));
  })));
};
ProductsTableFoot.propTypes = {
  plans: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  onPlanSelect: _propTypes["default"].func
};